// extracted by mini-css-extract-plugin
module.exports = {"border":"VipClub_border__PONS3","box":"VipClub_box__ARFPv","radiusLeft":"VipClub_radiusLeft__Zs0wt","radiusRight":"VipClub_radiusRight__O2_L3","collapse":"VipClub_collapse__fT4e_"};